// extracted by mini-css-extract-plugin
export default {"container":"otc_container__Lfb+5","header":"otc_header__xnYDI","tableContainer":"otc_tableContainer__viChn"};